/**
 * Shared constants for DayniteJs.
 * @module Constants
 */

/**
 * Default available themes.
 * @type {string[]}
 */
export const DEFAULT_THEMES = ['light', 'dark'];

/**
 * Default theme name.
 * @type {string}
 */
export const DEFAULT_THEME = 'light';

/**
 * Default localStorage key for theme.
 * @type {string}
 */
export const DEFAULT_STORAGE_KEY = 'DayniteJs-theme';
